import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VehicleTransferRequestService from "../services/vehicleTransferRequestService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import VehicleHireService from "../services/vehicleHireService";
import StatusDetailsModal from "../components/vehicleTransfer/StatusDetailsModal";
import CompanyService from "../services/companyService";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";
import moment from "moment";


export default function ViewVehicleTransfer() {
  const [transfers, setTransfers] = useState([]);
  const [localTransfers, setlocalTransfers] = useState([]);
  const [companyTransfers, setCompanyTransfers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [approveError, setApproveError] = useState("");
  const navigate = useNavigate();
  // const messageTimer = useRef(null);
  // const approveErrorTimer = useRef(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusItem, setStatusItem] = useState(null);

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [releaseItem, setReleaseItem] = useState(null);
  const [releaseDate, setReleaseDate] = useState("");
  // GET ROLE
  const { roleName, roleId } = StorageService.loginData();
  // const canSeeActions = roleName === "Super Admin" || roleName === "Data Admin";
  // const isNormalUser = roleName !== "Super Admin" && roleName !== "Data Admin";

  //const isNormalUser = !isAdmin;

  const localTableTitle =
    roleId === "1" || roleId === "2" ? "Local Requests" : "Vehicle Request";

  // APPROVE MODAL STATES
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showCompanyApproveModal, setShowCompanyApproveModal] = useState(false);
  const [approveItem, setApproveItem] = useState(null);
  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedVehicleNo, setSelectedVehicleNo] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [approveNote, setApproveNote] = useState("");
  const [vehicleFilter, setVehicleFilter] = useState("all");

  // REJECT MODAL STATES
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectItem, setRejectItem] = useState(null);
  const [rejectNote, setRejectNote] = useState("");

  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferItem, setTransferItem] = useState(null);
  const [transferNote, setTransferNote] = useState("");
  const [releaseNote, setReleaseNote] = useState("");
  // const [showEscalateModal, setShowEscalateModal] = useState(false);
  // const [escalateItem, setEscalateItem] = useState(null);
  // const [escalateNote, setEscalateNote] = useState("");

  const [showAdminReceiveModal, setShowAdminReceiveModal] = useState(false);
  const [receiveItem, setReceiveItem] = useState(null);
  const [receiveDate, setReceiveDate] = useState("");
  const [receiveNote, setReceiveNote] = useState("");


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);

    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Vehicle_Transfer_Request,
    showMessage
  );

  const isAdmin = roleId === "1" || roleId === "2";

  // const canSeeActions = isAdmin && permission?.canView === 1;

  const calculateTotalDays = (startDate, endDate) => {
    if (!startDate || !endDate) return "-";
    const start = moment(startDate);
    const end = moment(endDate);
    if (!start.isValid() || !end.isValid()) return "-";
    const diff = end.diff(start, "days") + 1;
    return diff >= 0 ? diff : 0;
  };

  useEffect(() => {
    if (permission === null) return;

    if (permission.canView === 1) {
      fetchTransfers();
    }
  }, [permission]);

  const openStatusModal = (item) => {
    setStatusItem(item);
    setShowStatusModal(true);
  };

  const openReleaseModal = () => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    if (!selected) {
      showMessage("Please select one record to release", "error");
      return;
    }

    const item = localTransfers.find(t => t.id === selected);

    if (!item) {
      showMessage("Invalid selection", "error");
      return;
    }

    if (item.status !== "Approved") {
      showMessage("Only Approved vehicle transfer requests can be released", "error");
      return;
    }

    setReleaseItem(item);
    setReleaseDate("");
    setReleaseNote("");
    setShowReleaseModal(true);
  };


  const openTransferModal = async (item) => {
    if (!can("canTransfer")) {
      showMessage("No permission", "error");
      return;
    }
    setTransferItem(item);
    setTransferNote("");
    setSelectedCompanyId("");
    setShowTransferModal(true);

    try {
      const currentCompanyId = StorageService.activeCompany().companyId;

      const res = await CompanyService.getActiveCompanies();
      const companies = res.data || [];

      //Exclude present company
      const filteredCompanies = companies.filter(
        (c) => String(c.id) !== String(currentCompanyId)
      );

      setCompanyList(filteredCompanies);
    } catch (err) {
      console.error("Failed to load companies", err);
    }
  };

  const showApproveError = (msg) => {
    setApproveError(msg);

    // if (approveErrorTimer.current) clearTimeout(approveErrorTimer.current);

    // approveErrorTimer.current = setTimeout(() => {
    //   setApproveError("");
    // }, 3000); // hide after 3 seconds
  };

  const openAdminReceiveModal = (item) => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    if (item.status !== "Released") {
      showMessage("Only Released records can be received", "error");
      return;
    }

    setReceiveItem(item);
    setReceiveDate(new Date().toISOString().split("T")[0]);
    setReceiveNote("");
    setShowAdminReceiveModal(true);
  };

  const submitReceive = async () => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    if (!receiveDate) {
      showMessage("Please give receive date", "error");
      return;
    }

    try {
      await VehicleTransferRequestService.receiveVehicle({
        transferRequestId: receiveItem.id,
        receiveDate: receiveDate,
        receiveNote: receiveNote,
        receivedBy: StorageService.loginData().employeeId,
      });

      showMessage("Vehicle received successfully", "success");
      setShowAdminReceiveModal(false);
      fetchTransfers();
    } catch (err) {
      console.error(err);
      showMessage("Receive failed", "error");
    }
  };


  // const handleCancelSelected = async () => {
  //   if (isAdmin) {
  //     showMessage("You are not allowed to cancel requests", "error");
  //     return;
  //   }

  //   if (selected.length === 0) {
  //     showMessage("Please select at least one record", "error");
  //     return;
  //   }

  //   // Only Pending records allowed
  //   const invalid = transfers.filter(
  //     t => selected.includes(t.id) && t.status !== "Pending"
  //   );

  //   if (invalid.length > 0) {
  //     showMessage("Only Pending requests can be cancelled", "error");
  //     return;
  //   }

  //   try {
  //     setLoading(true);

  //     const employeeId = StorageService.loginData().employeeId;
  //     const today = new Date().toISOString().split("T")[0];

  //     for (const id of selected) {
  //       const item = transfers.find(t => t.id === id);

  //       await VehicleTransferRequestService.update(id, {
  //         ...item,
  //         status: "Cancelled",
  //         cancelledBy: employeeId,
  //         cancelledDate: today,
  //       });
  //     }

  //     // Update UI
  //     setTransfers(prev =>
  //       prev.map(row =>
  //         selected.includes(row.id)
  //           ? { ...row, status: "Cancelled" }
  //           : row
  //       )
  //     );

  //     setSelected([]);
  //     showMessage("Request cancelled successfully", "success");
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Failed to cancel request", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCancelSelected = async () => {
    if (!can("canCancel")) {
      showMessage("No permission", "error");
      return;
    }
    if (isAdmin) {
      showMessage("You are not allowed to cancel requests", "error");
      return;
    }

    if (!selected) {
      showMessage("Please select a record", "error");
      return;
    }

    const item = transfers.find(t => t.id === selected);

    if (!item) {
      showMessage("Invalid selection", "error");
      return;
    }

    // Only Pending allowed
    if (item.status !== "Pending") {
      showMessage("Only Pending requests can be cancelled", "error");
      return;
    }

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel this vehicle transfer request for project "${item.projectName} - ${item.projectCode}"?`
    );

    if (!confirmCancel) return;

    try {
      setLoading(true);

      const employeeId = StorageService.loginData().employeeId;
      const today = new Date().toISOString().split("T")[0];

      await VehicleTransferRequestService.update(selected, {
        ...item,
        status: "Cancelled",
        cancelledBy: employeeId,
        cancelledDate: today,
      });

      // Update UI
      setTransfers(prev =>
        prev.map(row =>
          row.id === selected
            ? { ...row, status: "Cancelled" }
            : row
        )
      );

      setlocalTransfers(prev =>
        prev.map(row =>
          row.id === selected
            ? { ...row, status: "Cancelled" }
            : row
        )
      );

      setSelected(null);
      showMessage("Request cancelled successfully", "success");
    } catch (err) {
      console.error(err);
      showMessage("Failed to cancel request", "error");
    } finally {
      setLoading(false);
    }
  };



  // useEffect(() => {
  //   fetchTransfers();
  // }, []);



  const fetchTransfers = async () => {
    try {
      const currentCompanyId = parseInt(StorageService.activeCompany().companyId);
      const response = await VehicleTransferRequestService.getAll();
      let all = response || [];
      let localTransfers = [];
      let companyTransfers = [];

      const employeeId = parseInt(StorageService.loginData().employeeId);


      // SUPER ADMIN → see only escalated records
      // if (roleName === "Super Admin") {
      //   all = all.filter(r => ((r.status === "Escalated" || r.status === "Transfered")));
      // }
      if (roleId === "1" || roleId === "2") {
        localTransfers = all.filter(r => (r.companyId === currentCompanyId) && r.status !== "Cancelled");
        companyTransfers = all.filter(r => (r.toCompanyId === currentCompanyId));
        console.log("company Transfers", companyTransfers);
      }
      else {
        //alert(employeeId);
        localTransfers = all.filter(r => (r.companyId == currentCompanyId && r.requestedBy == employeeId));

      }

      // if (roleName === "Super Admin" || roleName === "Data Admin") {
      //   all = all.filter(r => r.status !== "Cancelled");
      // }

      setTransfers(all);
      setlocalTransfers(localTransfers);
      setCompanyTransfers(companyTransfers);
    } catch (error) {
      console.error(error);
      setTransfers([]);
    }
  };



  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const handleSelect = (id) => {
    setSelected(id);
  };


  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelected(transfers.map((t) => t.id));
  //   } else {
  //     setSelected([]);
  //   }
  // };

  const handleAdd = () => navigate("/cpnl/vehicletransfer/add");

  // OPEN APPROVE MODAL
  const openApproveModal = async (item) => {
    if (!can("canApprove")) {
      showMessage("No permission", "error");
      return;
    }
    setApproveItem(item);
    setSelectedVehicleId("");
    setApproveNote("");
    setVehicleFilter("all");
    setShowApproveModal(true);
    const companyId = StorageService.activeCompany().companyId;
    try {
      // alert(companyId, item.vehicleTypeId, item.projectId);
      const res = await VehicleHireService.getTransferVehicles(companyId, item.vehicleTypeId, item.projectId);
      const vehicles = res.data || [];

      setVehicleList(vehicles);
    } catch (err) {
      showMessage("Failed to load vehicles", "error");
    }
  };

  // OPEN  Company APPROVE MODAL
  const openCompanyApproveModal = async (item) => {
    if (!can("canApprove")) {
      showMessage("No permission", "error");
      return;
    }
    setApproveItem(item);
    setSelectedVehicleId("");
    setApproveNote("");
    setVehicleFilter("all");
    setShowCompanyApproveModal(true);
    const companyId = StorageService.activeCompany().companyId;
    try {
      // alert(companyId, item.vehicleTypeId, item.projectId);
      const res = await VehicleHireService.getTransferVehicles(companyId, item.vehicleTypeId, item.projectId);
      const vehicles = res.data || [];

      setVehicleList(vehicles);
    } catch (err) {
      showMessage("Failed to load vehicles", "error");
    }
  };

  const submitRelease = async () => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    if (!releaseDate) {
      showMessage("Please select release date", "error");
      return;
    }

    try {
      await VehicleTransferRequestService.releaseVehicle({
        transferRequestId: releaseItem.id,
        releaseDate: releaseDate,
        releaseNote: releaseNote,
        releasedBy: StorageService.loginData().employeeId,
      });

      showMessage("Vehicle released successfully", "success");
      setShowReleaseModal(false);
      fetchTransfers();
    } catch (err) {
      console.error(err);
      showMessage("Release failed", "error");
    }
  };


  // OPEN REJECT MODAL
  const openRejectModal = (item) => {
    if (!can("canReject")) {
      showMessage("No permission", "error");
      return;
    }
    setRejectItem(item);
    setRejectNote("");
    setShowRejectModal(true);
  };


  // SUBMIT APPROVAL
  const submitApprove = async () => {
    if (!can("canApprove")) {
      showMessage("No permission", "error");
      return;
    }
    if (!selectedVehicleId) {
      showApproveError("Please select a vehicle!");
      return;
    }

    const employeeId = StorageService.loginData().employeeId;
    const today = new Date().toISOString().split("T")[0];
    const companyId = StorageService.activeCompany().companyId;
    try {
      // 1️⃣ Insert approval details
      await VehicleTransferRequestService.approveLocalVehicleRequest(

        {

          transferRequestId: approveItem.id,
          companyId: companyId,
          approvedBy: employeeId,
          approvedDate: today,
          approvedNotes: approveNote,
          vehicleTypeId: approveItem.vehicleTypeId,
          projectId: approveItem.projectId,
          assignedProjectId: selectedProjectId,
          vehicleId: selectedVehicleId,
          registrationNo: selectedVehicleNo,
          startDate: approveItem.startDate,
          endDate: approveItem.endDate,
        });

      // 2️⃣ Update main table
      await handleStatusChange(approveItem, "Approved", selectedVehicleId, approveNote);

      showMessage("Approved successfully", "success");
      setShowApproveModal(false);
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || "Approval failed";
      showMessage(errMsg, "error");
    }
  };

  // SUBMIT APPROVAL
  const submitCompanyApprove = async () => {
    if (!can("canApprove")) {
      showMessage("No permission", "error");
      return;
    }
    if (!selectedVehicleId) {
      showApproveError("Please select a vehicle!");
      return;
    }

    const employeeId = StorageService.loginData().employeeId;
    const today = new Date().toISOString().split("T")[0];
    const companyId = StorageService.activeCompany().companyId;
    try {
      // 1️⃣ Insert approval details
      await VehicleTransferRequestService.approveCompanyVehicleRequest(

        {

          transferRequestId: approveItem.id,
          companyId: approveItem.companyId,
          approvedBy: employeeId,
          approvedDate: today,
          approvedNotes: approveNote,
          vehicleTypeId: approveItem.vehicleTypeId,
          projectId: approveItem.projectId,
          assignedProjectId: selectedProjectId,
          registrationNo: selectedVehicleNo,
          vehicleId: selectedVehicleId,
          startDate: approveItem.startDate,
          endDate: approveItem.endDate,
        });

      // 2️⃣ Update main table
      await handleStatusChange(approveItem, "Approved", selectedVehicleId, approveNote);

      showMessage("Approved successfully", "success");
      setShowCompanyApproveModal(false);
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.message || "Approval failed";
      showMessage(errMsg, "error");
    }
  };

  // SUBMIT REJECTION
  const submitReject = async () => {
    if (!can("canReject")) {
      showMessage("No permission", "error");
      return;
    }
    if (!rejectNote.trim()) {
      showMessage("Please enter rejection note!", "error");
      return;
    }

    const employeeId = StorageService.loginData().employeeId;
    const today = new Date().toISOString().split("T")[0];

    try {
      // 1️⃣ Insert rejection details
      await VehicleTransferRequestService.rejectLocalVehicleRequest({
        transferRequestId: rejectItem.id,
        rejectedBy: employeeId,
        rejectedNotes: rejectNote
      });

      // 2️⃣ Update main table
      await handleStatusChange(rejectItem, "Rejected", null, rejectNote);

      showMessage("Rejected successfully", "success");
    } catch (err) {
      console.error(err);
      showMessage("Rejection failed", "error");
    }

    setShowRejectModal(false);
  };

  // const submitEscalate = async () => {
  //   if (!escalateNote.trim()) {
  //     showMessage("Please enter escalation note!", "error");
  //     return;
  //   }

  //   const employeeId = StorageService.loginData().employeeId;
  //   const today = new Date().toISOString().split("T")[0];

  //   try {
  //     // 1️⃣ Insert escalation details
  //     await VehicleTransferRequestService.saveEscalateDetails({
  //       transferRequestId: escalateItem.id,
  //       escalatedBy: employeeId,
  //       escalatedNotes: escalateNote,
  //       escalatedDate: today
  //     });

  //     // 2️⃣ Update main table
  //     await handleStatusChange(escalateItem, "Escalated", null, escalateNote);

  //     showMessage("Escalated successfully", "success");
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Escalation failed", "error");
  //   }

  //   setShowEscalateModal(false);
  // };

  const submitTransfer = async () => {
    if (!can("canTransfer")) {
      showMessage("No permission", "error");
      return;
    }
    if (!transferNote.trim()) {
      showMessage("Please enter Transfer  note!", "error");
      return;
    }

    const employeeId = StorageService.loginData().employeeId;
    const today = new Date().toISOString().split("T")[0];

    try {
      // 1️⃣ Insert escalation details
      await VehicleTransferRequestService.transferVehicleRequest({
        transferRequestId: transferItem.id,
        transferedBy: employeeId,
        transfereddNotes: transferNote,
        transferedDate: today,
        toCompanyId: selectedCompanyId,
      });

      // 2️⃣ Update main table
      await handleStatusChange(transferItem, "Transfered", null, transferNote);

      showMessage("Transfered successfully", "success");
    } catch (err) {
      console.error(err);
      showMessage("Transfer failed", "error");
    }

    setShowTransferModal(false);
  };
  // const openEscalateModal = (item) => {
  //   setEscalateItem(item);
  //   setEscalateNote("");
  //   setShowEscalateModal(true);
  // };

  // STATUS CHANGE FUNCTION
  const handleStatusChange = async (item, newStatus, assignedVehicleId = null, note = "") => {
    if (!newStatus) return;

    setLoading(true);

    try {
      const employeeId = StorageService.loginData().employeeId;
      const today = new Date().toISOString().split("T")[0];

      const payload = {
        companyId: item.companyId,
        projectId: item.projectId,
        vehicleTypeId: item.vehicleTypeId,
        assignedVehicleId: assignedVehicleId || null,
        note: note || "",
        startDate: item.startDate?.substring(0, 10) || null,
        endDate: item.endDate?.substring(0, 10) || null,
        requestedDate: item.requestedDate?.substring(0, 10) || null,
        requestedBy: item.requestedBy,
        status: newStatus,
        approvedBy: newStatus === "Approved" ? employeeId : null,
        approvedDate: newStatus === "Approved" ? today : null,
        rejectedBy: newStatus === "Rejected" ? employeeId : null,
        rejectedDate: newStatus === "Rejected" ? today : null,
      };

      await VehicleTransferRequestService.update(item.id, payload);

      showMessage(`Status updated to ${newStatus}`, "success");

      setTransfers((prev) =>
        prev.map((row) => (row.id === item.id ? { ...row, ...payload } : row))
      );
      setlocalTransfers((prev) =>
        prev.map((row) => (row.id === item.id ? { ...row, ...payload } : row))
      );
      setCompanyTransfers((prev) =>
        prev.map((row) => (row.id === item.id ? { ...row, ...payload } : row))
      );
    } catch (err) {
      console.error(err);
      showMessage("Failed to update status", "error");
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Pending":
        return "bg-info text-dark";
      case "Approved":
        return "bg-success text-dark";
      case "Rejected":
        return "bg-danger text-dark";
      case "Cancelled":
        return "bg-dark text-white";
      case "Transfered":
        return "bg-primary text-white";
      case "Received":
        return "bg-warning text-dark";
      default:
        return "bg-secondary";
    }
  };

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  const showLocalVehicleColumn = localTransfers.some(t =>
    ["Approved", "Released", "Received", "Transfered"].includes(t.status)
  );

  const showCompanyVehicleColumn = companyTransfers.some(t =>
    ["Approved", "Released", "Received", "Transfered"].includes(t.status)
  );

  // ADD THIS SAFETY
  if (!permission || permission.canView === 0) {
    return (
      <>
        <Breadcrumb pageTitle="Unauthorized" secondTitle="Employee prmission" />
        <div className="card p-4 text-center text-danger">
          <h5>You don't have permission. Please contact administrator.</h5>
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcrumb pageTitle="Vehicle Transfer" secondTitle="Vehicle Management" />

      <div className="card p-3 bg-white shadow-sm">

        {/* ALERT */}
        {/* {message && (
          <div
            className={
              `alert ${msgType === "success" ? "alert-success" : "alert-danger"} d-flex justify-content-between align-items-center mb-2 p-2`}
          >
            <span>{message}</span>
            <button className="btn-close" onClick={closeMessage}></button>
          </div>
        )} */}
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
        {/* TOP BUTTONS */}
        <div className="mb-3 pb-2 border-bottom d-flex gap-2">

          {/* Only Normal User should see Add & Cancel */}
          {/* {isAdmin ? "Admin" :  + typeof (roleId)} */}
          {!isAdmin && (
            <>
              {can("canAdd") && (
                <button className="btn btn-success" onClick={handleAdd} disabled={loading}>
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}

              {can("canCancel") && (
                <button
                  className="btn btn-secondary"
                  onClick={handleCancelSelected}
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  onClick={openReleaseModal}
                  disabled={loading}
                >
                  <i className="ti ti-upload me-1"></i> Release
                </button>
              )}
            </>
          )}
        </div>

        {/* TABLE */}
        <div >
          <div><h5>{localTableTitle}</h5>
            <div className="table-responsive">
              <table className="table table-striped table-bordered mb-0">
                <thead className="table-light" >
                  <tr>
                    {/* <th>
                      <input
                        type="checkbox"
                        checked={selected.length === localTransfers.length && localTransfers.length > 0}
                        onChange={handleSelectAll}
                      />
                    </th> */}
                    <th>Select</th>
                    <th>Project</th>
                    <th>Vehicle Type</th>
                    {showLocalVehicleColumn && <th>Vehicle</th>}
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Total Days</th>
                    <th>Requested Date</th>
                    <th>Requested By</th>
                    <th>Status</th>

                    {/* CONDITIONAL ACTION HEADER */}
                    {/* {canSeeActions && <th className="text-center">Action</th>} */}
                    {permission?.canView === 1 && isAdmin && (
                      <th className="text-center">Action</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {localTransfers.length > 0 ? (
                    localTransfers.map((t) => {
                      const status = t.status || "Pending";
                      const disabled = status === "Approved" || status === "Rejected" || status === "Transfered";

                      return (
                        <tr key={t.id}>
                          <td>
                            <input
                              type="radio"
                              name="vehicleTransfer"
                              checked={selected === t.id}
                              onChange={() => handleSelect(t.id)}
                            />
                          </td>

                          <td>{t.projectName || "-"}-{t.projectCode || "-"}</td>
                          <td>{t.vehicleType || "-"}</td>
                          {showLocalVehicleColumn && (
                            <td>{t.vehicleName ? `${t.vehicleName} (${t.registrationNo || "-"})` : "-"}</td>
                          )}
                          <td>{utility.formatDateDDMMMYYYY(t.startDate) || "-"}</td>
                          <td>{utility.formatDateDDMMMYYYY(t.endDate) || "-"}</td>
                          <td>{calculateTotalDays(t.startDate, t.endDate)}</td>
                          <td>{utility.formatDateDDMMMYYYY(t.requestedDate) || "-"}</td>
                          <td>{t.requestedByName || "-"}</td>

                          <td>
                            <span
                              className={`badge ${getStatusBadgeClass(status)}`}
                              style={{ cursor: "pointer" }}
                              onClick={() => openStatusModal(t)}
                            >
                              {status}
                            </span>
                          </td>

                          {/* CONDITIONAL ACTION COLUMN */}
                          {permission?.canView === 1 && isAdmin && (
                            <td className="text-center d-flex justify-content-center gap-3">

                              {/* TRANSFER → Super Admin + Data Admin */}
                              {isAdmin && can("canTransfer") && (
                                <span title="Transfer">
                                  <button
                                    className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                                    disabled={t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered" || t.status === "Received"}
                                    onClick={() => openTransferModal(t)}
                                    style={{
                                      cursor:
                                        (t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered")
                                          ? "not-allowed"
                                          : "pointer"
                                    }}
                                  >
                                    <i className="ti ti-arrow-forward-up" style={{ fontSize: 18 }}></i>
                                  </button>
                                </span>
                              )}

                              {/* APPROVE / REJECT → ONLY Data Admin */}

                              <>

                                <span title="Approve">
                                  {isAdmin && can("canApprove") && (
                                    <button
                                      className="btn btn-success btn-sm d-flex align-items-center justify-content-center"

                                      disabled={t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered" || t.status === "Received"}
                                      onClick={() => openApproveModal(t)}
                                      style={{
                                        cursor:
                                          (t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered")
                                            ? "not-allowed"
                                            : "pointer"
                                      }}
                                    >
                                      <i className="ti ti-circle-check" style={{ fontSize: 18 }}></i>
                                    </button>
                                  )}
                                </span>

                                <span title="Reject">
                                  {isAdmin && can("canReject") && (
                                    <button
                                      className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"

                                      disabled={t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered" || t.status === "Received"}
                                      onClick={() => openRejectModal(t)}
                                      style={{
                                        cursor:
                                          (t.status === "Released" || t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered")
                                            ? "not-allowed"
                                            : "pointer"
                                      }}
                                    >
                                      <i className="ti ti-circle-x" style={{ fontSize: 18 }}></i>
                                    </button>
                                  )}
                                </span>

                                <span title="Receive">
                                  {isAdmin && can("canModify") && (
                                    <button
                                      className="btn btn-warning btn-sm d-flex align-items-center justify-content-center"
                                      disabled={t.status !== "Released"}
                                      onClick={() => openAdminReceiveModal(t)}
                                      style={{ pointerEvents: t.status !== "Released" ? "none" : "auto" }}
                                    >
                                      <i className="ti ti-arrow-down" style={{ fontSize: 18 }}></i>
                                    </button>
                                  )}
                                </span>


                              </>


                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={permission?.canView === 1 && isAdmin ? (showLocalVehicleColumn ? "11" : "10") : (showLocalVehicleColumn ? "10" : "9")} className="text-center text-muted">
                        No Local vehicle transfer records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {permission?.canView === 1 && isAdmin && (
            <div><h5>Company Requests</h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      {/* <th>
                        <input
                          type="checkbox"
                          checked={selected.length === companyTransfers.length && companyTransfers.length > 0}
                          onChange={handleSelectAll}
                        />
                      </th> */}
                      <th>Select</th>
                      <th>Company</th>
                      <th>Project</th>
                      <th>Vehicle Type</th>
                      {showCompanyVehicleColumn && <th>Vehicle</th>}
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Total Days</th>
                      <th>Requested Date</th>
                      <th>Requested By</th>
                      <th>Status</th>

                      {/* CONDITIONAL ACTION HEADER */}
                      {/* {canSeeActions && <th className="text-center">Action</th>} */}
                      {permission?.canView === 1 && isAdmin && (
                        <th className="text-center">Action</th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {companyTransfers.length > 0 ? (
                      companyTransfers.map((t) => {
                        const status = t.status || "Pending";
                        const disabled = status === "Approved" || status === "Rejected" || status === "Transfered";

                        return (
                          <tr key={t.id}>
                            <td>
                              <input
                                type="radio"
                                name="vehicleTransfer"
                                checked={selected === t.id}
                                onChange={() => handleSelect(t.id)}
                              />
                            </td>
                            <td>{t.companyName || "-"}</td>
                            <td>{t.projectName || "-"}</td>
                            <td>{t.vehicleType || "-"}</td>
                            {showCompanyVehicleColumn && (
                              <td>{t.vehicleName ? `${t.vehicleName} (${t.registrationNo || "-"})` : "-"}</td>
                            )}
                            <td>{utility.formatDateDDMMMYYYY(t.startDate) || "-"}</td>
                            <td>{utility.formatDateDDMMMYYYY(t.endDate) || "-"}</td>
                            <td>{calculateTotalDays(t.startDate, t.endDate)}</td>
                            <td>{utility.formatDateDDMMMYYYY(t.requestedDate) || "-"}</td>
                            <td>{t.requestedByName || "-"}</td>

                            <td>
                              <span
                                className={`badge ${getStatusBadgeClass(status)}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => openStatusModal(t)}
                              >
                                {status}
                              </span>
                            </td>

                            {/* CONDITIONAL ACTION COLUMN */}
                            {permission?.canView === 1 && isAdmin && (
                              <td className="text-center d-flex justify-content-center gap-3">

                                {/* TRANSFER → Super Admin + Data Admin */}
                                {/* {(roleName === "Super Admin" || roleName === "Data Admin") && (
                                  <button
                                    className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                                    title="Transfer"
                                    disabled={t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered"}
                                    onClick={() => openTransferModal(t)}
                                  >
                                    <i className="ti ti-arrow-forward-up" style={{ fontSize: 18 }}></i>
                                  </button>
                                )} */}

                                {/* APPROVE / REJECT → ONLY Data Admin */}

                                <>
                                  <span title="Approve">
                                    {isAdmin && can("canApprove") && (
                                      <button
                                        className="btn btn-success btn-sm d-flex align-items-center justify-content-center"

                                        disabled={t.status === "Approved" || t.status === "Rejected"}
                                        onClick={() => openCompanyApproveModal(t)}
                                        style={{
                                          cursor:
                                            (t.status === "Approved" || t.status === "Rejected")
                                              ? "not-allowed"
                                              : "pointer"
                                        }}
                                      >
                                        <i className="ti ti-circle-check" style={{ fontSize: 18 }}></i>
                                      </button>
                                    )}
                                  </span>

                                  <span title="Reject">
                                    {isAdmin && can("canReject") && (
                                      <button
                                        className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"

                                        disabled={t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered"}
                                        onClick={() => openRejectModal(t)}
                                        style={{
                                          cursor:
                                            (t.status === "Approved" || t.status === "Rejected" || t.status === "Transfered")
                                              ? "not-allowed"
                                              : "pointer"
                                        }}
                                      >
                                        <i className="ti ti-circle-x" style={{ fontSize: 18 }}></i>
                                      </button>
                                    )}
                                  </span>
                                </>


                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={permission?.canView === 1 && isAdmin ? (showCompanyVehicleColumn ? "12" : "11") : (showCompanyVehicleColumn ? "11" : "10")} className="text-center text-muted">
                          No Company vehicle transfer records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* APPROVE MODAL */}
        {showApproveModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                maxHeight: "90vh",
                overflowY: "auto",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Approve Vehicle Transfer</h5>

              {approveError && (
                <div className="alert alert-danger py-2">
                  {approveError}
                </div>
              )}

              <div className="mb-2">
                <label className="form-label fw-semibold">Approval Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={new Date().toISOString().split("T")[0]}
                  disabled
                />
              </div>

              {/* Project */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Project</label>
                <input type="text" className="form-control" value={approveItem ? `${approveItem.projectName || "-"}-${approveItem.projectCategoryName || "-"}-${approveItem.projectCode || "-"}` : "-"} disabled />
              </div>

              {/* Vehicle Type */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle Type</label>
                <input type="text" className="form-control" value={approveItem?.vehicleType || "-"} disabled />
              </div>

              {/* Vehicle Filter Dropdown */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Filter Vehicles</label>
                <select
                  className="form-select"
                  value={vehicleFilter}
                  onChange={(e) => {
                    setVehicleFilter(e.target.value);
                    setSelectedVehicleId("");
                    setSelectedProjectId("");
                    setSelectedVehicleNo("");
                  }}
                >
                  <option value="all">Show All</option>
                  <option value="assigned">Show Assigned</option>
                  <option value="unassigned">Show Unassigned</option>
                </select>
              </div>

              {/* Vehicle Dropdown */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Select Vehicle</label>
                <select
                  className="form-select"
                  value={selectedVehicleId}
                  onChange={(e) => {
                    const vehicleId = e.target.value;
                    setSelectedVehicleId(vehicleId);

                    const selectedVehicle = vehicleList.find(
                      (v) => String(v.vehicleId) === String(vehicleId)
                    );

                    setSelectedProjectId(selectedVehicle?.assignProjectId || "");
                    setSelectedVehicleNo(selectedVehicle?.registrationNo || "");
                    console.log("Vehicle ID:", selectedVehicleId);
                    console.log("Assigned Project ID:", selectedProjectId);
                    console.log("registrationNo:", selectedVehicleNo);
                  }}
                >
                  <option value="">-- Select Vehicle --</option>
                  {(vehicleFilter === "all" || vehicleFilter === "assigned") && (
                    <optgroup label="Assigned Vehicles">
                      {vehicleList
                        .filter((v) => v.projectName)
                        .map((v) => (
                          <option
                            key={v.vehicleId}
                            value={v.vehicleId}
                            assignProjectId={v.assignProjectId}
                            registrationNo={v.registrationNo}
                          >
                            {v.registrationNo} - {v.vehicleName} - (Project: {v.projectName})
                          </option>
                        ))}
                    </optgroup>
                  )}
                  {(vehicleFilter === "all" || vehicleFilter === "unassigned") && (
                    <optgroup label="Unassigned Vehicles">
                      {vehicleList
                        .filter((v) => !v.projectName)
                        .map((v) => (
                          <option
                            key={v.vehicleId}
                            value={v.vehicleId}
                            assignProjectId={v.assignProjectId}
                            registrationNo={v.registrationNo}
                          >
                            {v.registrationNo} - {v.vehicleName} - (Project: Not Assigned)
                          </option>
                        ))}
                    </optgroup>
                  )}
                </select>
              </div>

              {/* Note */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Approval Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter note"
                  value={approveNote}
                  onChange={(e) => setApproveNote(e.target.value)}
                ></textarea>
              </div>
              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button className="btn btn-secondary" onClick={() => setShowApproveModal(false)}>
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button className="btn btn-success" onClick={submitApprove}>
                  <i className="ti ti-circle-check me-1"></i> Approve Transfer
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Company Transfers Approve  MODAL */}
        {showCompanyApproveModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                maxHeight: "90vh",
                overflowY: "auto",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Approve Vehicle Transfer</h5>

              {approveError && (
                <div className="alert alert-danger py-2">
                  {approveError}
                </div>
              )}

              <div className="mb-2">
                <label className="form-label fw-semibold">Approval Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={new Date().toISOString().split("T")[0]}
                  disabled
                />
              </div>

              {/* Project */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Project</label>
                <input type="text" className="form-control" value={approveItem ? `${approveItem.projectName || "-"}-${approveItem.projectCategoryName || "-"}-${approveItem.projectCode || "-"}` : "-"} disabled />
              </div>

              {/* Vehicle Type */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle Type</label>
                <input type="text" className="form-control" value={approveItem?.vehicleType || "-"} disabled />
              </div>

              {/* Vehicle Filter Dropdown */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Filter Vehicles</label>
                <select
                  className="form-select"
                  value={vehicleFilter}
                  onChange={(e) => {
                    setVehicleFilter(e.target.value);
                    setSelectedVehicleId("");
                    setSelectedProjectId("");
                    setSelectedVehicleNo("");
                  }}
                >
                  <option value="all">Show All</option>
                  <option value="assigned">Show Assigned</option>
                  <option value="unassigned">Show Unassigned</option>
                </select>
              </div>

              {/* Vehicle Dropdown */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Select Vehicle</label>
                <select
                  className="form-select"
                  value={selectedVehicleId}
                  onChange={(e) => {
                    const vehicleId = e.target.value;
                    setSelectedVehicleId(vehicleId);

                    const selectedVehicle = vehicleList.find(
                      (v) => String(v.vehicleId) === String(vehicleId)
                    );

                    setSelectedProjectId(selectedVehicle?.assignProjectId || "");
                    setSelectedVehicleNo(selectedVehicle?.registrationNo || "");
                    console.log("Vehicle ID:", selectedVehicleId);
                    console.log("Assigned Project ID:", selectedProjectId);
                    console.log("registrationNo:", selectedVehicleNo);
                  }}
                >
                  <option value="">-- Select Vehicle --</option>
                  {(vehicleFilter === "all" || vehicleFilter === "assigned") && (
                    <optgroup label="Assigned Vehicles">
                      {vehicleList
                        .filter((v) => v.projectName)
                        .map((v) => (
                          <option
                            key={v.vehicleId}
                            value={v.vehicleId}
                            assignProjectId={v.assignProjectId}
                            registrationNo={v.registrationNo}
                          >
                            {v.registrationNo} - {v.vehicleName} - (Project: {v.projectName})
                          </option>
                        ))}
                    </optgroup>
                  )}
                  {(vehicleFilter === "all" || vehicleFilter === "unassigned") && (
                    <optgroup label="Unassigned Vehicles">
                      {vehicleList
                        .filter((v) => !v.projectName)
                        .map((v) => (
                          <option
                            key={v.vehicleId}
                            value={v.vehicleId}
                            assignProjectId={v.assignProjectId}
                            registrationNo={v.registrationNo}
                          >
                            {v.registrationNo} - {v.vehicleName} - (Project: Not Assigned)
                          </option>
                        ))}
                    </optgroup>
                  )}
                </select>
              </div>

              {/* Note */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Approval Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter note"
                  value={approveNote}
                  onChange={(e) => setApproveNote(e.target.value)}
                ></textarea>
              </div>
              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button className="btn btn-secondary" onClick={() => setShowCompanyApproveModal(false)}>
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button className="btn btn-success" onClick={submitCompanyApprove}>
                  <i className="ti ti-circle-check me-1"></i> Approve Transfer
                </button>
              </div>
            </div>
          </div>
        )}
        {/* REJECT MODAL */}
        {showRejectModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Reject Vehicle Transfer</h5>

              {/* Project */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Project</label>
                <input
                  type="text"
                  className="form-control"
                  value={rejectItem ? `${rejectItem.projectName || "-"}-${rejectItem.projectCategoryName || "-"}-${rejectItem.projectCode || "-"}` : "-"}
                  disabled
                />
              </div>

              <div className="mb-2">
                <label className="form-label fw-semibold">Rejection Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={new Date().toISOString().split("T")[0]}
                  disabled
                />
              </div>

              {/* Rejection Note */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Rejection Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter rejection reason"
                  value={rejectNote}
                  onChange={(e) => setRejectNote(e.target.value)}
                ></textarea>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button className="btn btn-secondary" onClick={() => setShowRejectModal(false)}>
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button className="btn btn-danger" onClick={submitReject}>
                  <i className="ti ti-circle-x me-1"></i> Reject
                </button>
              </div>
            </div>
          </div>
        )}
        {showTransferModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Transfer Vehicle</h5>
              <div className="mb-2">
                <label className="form-label fw-semibold">To Company</label>
                <select
                  className="form-select"
                  value={selectedCompanyId}
                  onChange={(e) => setSelectedCompanyId(e.target.value)}
                >
                  <option value="">-- Select Company --</option>

                  {companyList.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.companyName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle Type</label>
                <input type="text" className="form-control" value={transferItem?.vehicleType || "-"} disabled />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter note"
                  value={transferNote}
                  onChange={(e) => setTransferNote(e.target.value)}
                ></textarea>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button className="btn btn-secondary" onClick={() => setShowTransferModal(false)}>
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button className="btn btn-primary" onClick={submitTransfer}>
                  <i className="ti ti-arrow-forward-up me-1"></i> Transfer
                </button>
              </div>
            </div>
          </div>
        )}

        {showReleaseModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Release Vehicle</h5>

              {/* Project */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Project</label>
                <input
                  type="text"
                  className="form-control"
                  value={releaseItem ? `${releaseItem.projectName || "-"}-${releaseItem.projectCategoryName || "-"}-${releaseItem.projectCode || "-"}` : "-"}
                  disabled
                />
              </div>

              {/* Vehicle Type */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle Type</label>
                <input
                  type="text"
                  className="form-control"
                  value={releaseItem?.vehicleType || "-"}
                  disabled
                />
              </div>

              {/* Vehicle */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle</label>
                <input
                  type="text"
                  className="form-control"
                  value={releaseItem ? `${releaseItem.vehicleName || "-"}/${releaseItem.ownerName || "N/A"} (${releaseItem.registrationNo || "-"})` : "-"}
                  disabled
                />
              </div>

              {/* Release Date */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Release Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={releaseDate}
                  onChange={(e) => setReleaseDate(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold">Release Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter note"
                  value={releaseNote}
                  onChange={(e) => setReleaseNote(e.target.value)}
                ></textarea>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowReleaseModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-warning"
                  onClick={submitRelease}
                >
                  Release
                </button>
              </div>
            </div>
          </div>
        )}

        {/* {showEscalateModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Escalate Vehicle Transfer</h5>

              
              <div className="mb-2">
                <label className="form-label fw-semibold">Escalation Date</label>
                <input
                  type="text"
                  className="form-control"
                  value={new Date().toISOString().split("T")[0]}
                  disabled
                />
              </div>

              
              <div className="mb-3">
                <label className="form-label fw-semibold">Escalation Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter escalation note"
                  value={escalateNote}
                  onChange={(e) => setEscalateNote(e.target.value)}
                ></textarea>
              </div>

              
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowEscalateModal(false)}
                >
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>

                <button
                  className="btn btn-warning"
                  onClick={submitEscalate}
                >
                  <i className="ti ti-alert-circle me-1"></i> Escalate
                </button>
              </div>
            </div>
          </div>
        )} */}

        {showAdminReceiveModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 999,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                zIndex: 1000,
              }}
            >
              <h5>Received Details</h5>

              {/* Project */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Project</label>
                <input
                  type="text"
                  className="form-control"
                  value={receiveItem ? `${receiveItem.projectName || "-"}-${receiveItem.projectCategoryName || "-"}-${receiveItem.projectCode || "-"}` : "-"}
                  disabled
                />
              </div>

              {/* Vehicle Type */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle Type</label>
                <input
                  type="text"
                  className="form-control"
                  value={receiveItem?.vehicleType || "-"}
                  disabled
                />
              </div>

              {/* Vehicle */}
              <div className="mb-2">
                <label className="form-label fw-semibold">Vehicle</label>
                <input
                  type="text"
                  className="form-control"
                  value={receiveItem ? `${receiveItem.vehicleName || "-"}/${receiveItem.ownerName || "N/A"} (${receiveItem.registrationNo || "-"})` : "-"}
                  disabled
                />
              </div>


              <div className="mb-3">
                <label className="form-label fw-semibold">Receive Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={receiveDate}
                  onChange={(e) => setReceiveDate(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Receive Note</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={receiveNote}
                  onChange={(e) => setReceiveNote(e.target.value)}
                ></textarea>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowAdminReceiveModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-warning"
                  onClick={submitReceive}
                >
                  Confirm Receive
                </button>
              </div>
            </div>
          </div>
        )}

        {/* STATUS DETAILS MODAL (READONLY) */}
        <StatusDetailsModal
          show={showStatusModal}
          item={statusItem}
          onClose={() => setShowStatusModal(false)}
        />
      </div>
    </>
  );
}
